<template>
    <div>
        <el-card>
            <div slot="header">
			    <span class="top_title">订单统计</span>
		    </div>
            <div>
                <div class="searchItem">
                    <div class="search">
                        <span class="searchtips">时间:</span>
                        <el-date-picker
                            v-model="searchDate.dateRan"
                            type="daterange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 230px"
                            :editable="false"
                            value-format="yyyy-MM-dd"
                            @change="changeDate"
                        >
                        </el-date-picker>
                    </div>
                    <div class="search">
                        <span class="searchtips">发货状态:</span>
                        <el-select v-model="searchDate.sendstate" placeholder="请选择" style="width: 120px;" clearable>
                            <el-option label="未发货" value="1">
                            </el-option>
                            <el-option label="已发货" value="2">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search">
                        <el-button @click="advancedDialog=true">高级搜索</el-button>
                    </div>
                    <div class="search">
                        <span class="searchtips">已通过订单:</span>
                        <el-switch
                        v-model="searchDate.confirmed"
                        :active-value="1"
                        :inactive-value="0"
                    />
                    </div>
                    <div class="search">
                        <el-button type="primary" icon='el-icon-search' @click="initSearchObj()">查询</el-button>
                    </div>
                </div>
                <el-form>
                    <span class="searchtips">统计方式:</span>
                    <el-button
                        :type="statisticType == 1 ? 'primary' : ''"
                        @click="changestaticType(1)"
                        v-if="$common.hasLimits('orderStaticisByCust')"
                        >客户</el-button
                    >
                    <el-button
                        :type="statisticType == 2 ? 'primary' : ''"
                        @click="changestaticType(2)"
                        v-if="$common.hasLimits('orderStaticisByEmp')"
                        >员工</el-button
                    >
                    <el-button
                        :type="statisticType == 3 ? 'primary' : ''"
                        @click="changestaticType(3)"
                        v-if="$common.hasLimits('orderStaticisByProd')"
                        >产品</el-button
                    >
                    <el-button
                        type="primary"
                        icon="el-icon-printer"
                        @click="print"
                        v-if="$common.checkWindowsEnv()"
                        >打印</el-button>
                    <el-button
                        type='primary'
                        icon="el-icon-document"
                        @click="changePdf"
                    >导出</el-button>
                </el-form>
                <el-table
                    v-loading="loading"
                    :data="tableData"
                    :summary-method="getSummaries"
                    show-summary
                    border
                    style="width: 100%; margin-top: 20px"
                >
                    <el-table-column label="操作" align="center" width="60px">
                        <template slot-scope="scope">
                            <el-button type="text" @click="expandChange(scope.row)">详细</el-button>
                        </template>
                    </el-table-column>
                    <template v-for="(col, index) in cols">
                        <el-table-column 
                            :key="index"  
                            :prop="col.prop" 
                            :label="col.label" 
                            :width="col.width"
                            align="left"
                        >
                            <template #header v-if="col.column">
                                {{col.label}}
                                <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                                <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                                <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                                <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                            </template>
                            <template slot-scope="{ row }">
                                <template v-if="col.type=='numType'">
                                    <template>
                                        <div>
                                            {{ row.dtnum }}笔
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div>{{row[col.prop]}}</div>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <div style="margin-top: 15px;text-align: right;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                    :page-sizes="[20, 50, 120, 250]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="totalNumber" :pager-count="5">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog title="高级搜索" :visible.sync="advancedDialog" width="60%">
			<el-form ref="advanceform" :inline="true" :model="searchDate" class="demo-form-inline" label-width="100px">
				<el-form-item label="客户" v-show="statisticType==1">
                    <SearchBox
                        :searchLabel="'customer'"
                        :showLabel="'cname'"
                        @changeSelect="changeSelect($event,'cids')"
                        ref="sb3"
                        :url="'/mobile/customer/listCustomer'"
                    ></SearchBox>
				</el-form-item>
                <el-form-item label="销售员" v-show="statisticType==2">
                    <SearchBox
                        :searchLabel="'query'"
                        @changeSelect="changeSelect($event,'emps')"
                        ref="sb2"
                        :url="'/mobile/employee/listEmployee'"
                    ></SearchBox>
				</el-form-item>
				<el-form-item label="商品">
                    <SearchBox @changeSelect="changeSelect($event,'pids')" ref="sb1"></SearchBox>
				</el-form-item>
				<el-form-item label="商品分类">
					<el-select
                    ref="protype"
                    v-model="searchDate.categoryName"
                    style="width:160px"
                    placeholder=""
                    filterable
                >
                    <el-option
                        :value="searchDate.pcategory"
                        :label="searchDate.categoryName"
                        style="
                            width: 160px;
                            height: 200px;
                            overflow: auto;
                            background-color: #fff;
                        "
                    >
                        <el-tree
                            ref="tree"
                            :data="classifyData"
                            node-key="id"
                            default-expand-all
                            @node-click="handleNodeClick"
                        />
                    </el-option>
                </el-select>
				</el-form-item>
				<el-form-item label="颜色">
					<el-input v-model="searchDate.color" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="尺码">
					<el-input v-model="searchDate.size" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item style="display: block;text-align: center;">
					<el-button @click="resetForm">重置</el-button>
					<el-button type="primary" @click="initSearchObj()">
						查询
					</el-button>
					<el-button @click="advancedDialog=false">
						取消
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
        <el-dialog title="订单统计详细" :visible.sync="summaryDetailDialog" width="90%">
            <el-table :data="selectRow.tableData" stripe border>
                <el-table-column prop="cname" label="客户名" min-width="100"></el-table-column>
                <el-table-column prop="pname" label="产品名" width="150"></el-table-column>
                <el-table-column prop="onumber" label="订单号" width="150"></el-table-column>
                <el-table-column prop="date" label="时间" width="150"></el-table-column>
                <el-table-column prop="spec" label="款式"></el-table-column>
                <el-table-column prop="ename" label="销售员"></el-table-column>
                <el-table-column prop="price" label="单价(元)"></el-table-column>
                <el-table-column prop="punit" label="单位"></el-table-column>
                <el-table-column prop="sendDesc" label="发货数量" min-width="120"></el-table-column>
                <el-table-column prop="notSendDesc" label="未发货数量" min-width="120"></el-table-column>
            </el-table>
        </el-dialog>
        <ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
    </div>
</template>

<script>
import ReportOrder from '../../components/printshare/reportorder.vue';
import editShare from '../../components/printshare/edit_share';
export default {
    components: { ReportOrder,editShare },
    data() {
        return {
            loading:false,
            advancedDialog:false,
            summaryDetailDialog:false,
            totalNumber:0,
            limit:20,
            page:1,
            cols:[
                {
                    label:'订单笔数',
                    prop:'num',
                    width:'120',
                    type:'numType',
                },{
                    label:'订货数量',
                    prop:'sdesc',
                    width:'180',
                    column:'sumAmount',
                },{
                    label:'订货金额(元)',
                    prop:'sumPrice',
                    width:'180',
                    column:'sumPrice',
                },{
                    label:'发货数量',
                    prop:'cdesc',
                    width:'180',
                    column:'sumSendedAmount',
                },{
                    label:'未发货数量',
                    prop:'ndesc',
                    width:'180',
                    column:'sumNotSendAmount',
                },
            ],
            searchDate: {
                confirmed:1,
                sendstate:"1",
                dateRan: [],
                pcategory:"",
                categoryName:"",
                color:"",
                size:"",
                pids:"",
                emps:"",
                cids:"",
                column:'',
                order:'',
            },
            searchObj:{
                limit:20,
                page:1,
                confirmed:1,
                sendstate:"1",
            },
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            statisticType: 1,
            tableData: [],
            os_total: 0,
            os_sumUnit: 0,
            os_sumPrice: 0,
            totalSendDesc:"",
            totalNotSendDesc:"",
            classifyData:[],
            selectRow:{},
        };
    },
    created(res) {
        if(this.$common.hasLimits('orderStaticisByCust')){
            this.statisticType = 1;
        }else if(this.$common.hasLimits('orderStaticisByEmp')){
            this.statisticType = 2;
        }else if(this.$common.hasLimits('orderStaticisByProd')){
            this.statisticType = 3;
        }
        this.getOrderStatistic();
        this.getClassify();
    },
    methods: {
        print(){
            let array = [];
            let cmp = this.$global.cmpId.cmp;
            array.push(cmp);
            let key = 1+this.statisticType;
            this.$nextTick(()=>{
                this.$refs.roder.extraOpen(key,array);
            })
        },
        changePdf(){
            let array = [1];
            let key = 1+this.statisticType;
            this.$nextTick(()=>{
                this.$refs.share.openList(array,key,this.searchObj);
            })
        },
        handleSizeChange(val){
            this.limit = val;
            this.searchObj.limit = val;
            this.searchObj.page = 1;
            this.getOrderStatistic();
        },
        handleCurrentChange(val){
            this.page = val
            this.searchObj.page = val;
            this.getOrderStatistic();
        },
        resetForm(){
            this.searchDate={
                confirmed:1,
                sendstate:"",
                dateRan: [],
                pcategory:"",
                categoryName:"",
                color:"",
                size:"",
                pids:"",
                emps:"",
                cids:"",
                column:"",
                order:"",
            }
            if(this.$refs.sb1){
                this.$refs.sb1.reset();
            }
            if(this.$refs.sb2){
                this.$refs.sb2.reset();
            }
            if(this.$refs.sb3){
                this.$refs.sb3.reset();
            }
        },
        changeSelect(e,key){
            this.searchDate[key] = e;
        },
        handleNodeClick(node) {
            this.searchDate.pcategory = node.id;
            this.searchDate.categoryName = node.label;
            this.$refs.protype.blur();
        },
        changeDate(){
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.searchDate.start = this.searchDate.dateRan[0]+" 00:00:00";
                this.searchDate.end = this.searchDate.dateRan[1]+" 23:59:59";
            }else{
                this.searchDate.start = "";
                this.searchDate.end = "";
            }
        },
        changestaticType(val) {
            if (val == this.statisticType) {
                return;
            }
            this.resetForm();
            this.searchObj.page = 1;
            this.statisticType = val;
            this.initSearchObj();
        },
        getSummaries() {
            const sums = [
                "总计",
                this.os_total + "笔",
                ,
                this.os_sumPrice,
                this.totalSendDesc,
                this.totalNotSendDesc
            ];
            return sums;
        },
        initSearchObj(){
            this.searchObj = {
                limit:this.limit,
                page:1,
                confirmed:this.searchDate.confirmed,
            }
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.searchObj.start = this.searchDate.dateRan[0]+" 00:00:00";
                this.searchObj.end = this.searchDate.dateRan[1]+" 23:59:59";
            }else{
                this.searchObj.start = "";
                this.searchObj.end = "";
            }
            if(this.searchDate.cids){
                this.searchObj.cids = this.searchDate.cids;
            }
            if(this.searchDate.emps){
                this.searchObj.emps = this.searchDate.emps;
            }
            if(this.searchDate.pids){
                this.searchObj.pids = this.searchDate.pids;
            }
            if(this.searchDate.sendstate){
                this.searchObj.sendstate = this.searchDate.sendstate;
            }
            if(this.searchDate.size){
                this.searchObj.size = this.searchDate.size;
            }
            if(this.searchDate.color){
                this.searchObj.color = this.searchDate.color;
            }
            if(this.searchDate.pcategory){
                this.searchObj.pcategory = this.searchDate.pcategory;
            }
            this.sortTime();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.searchObj.column = this.searchDate.column;
                this.searchObj.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.searchObj.column;
                delete this.searchObj.order;
            }
            this.getOrderStatistic();
        },
        getOrderStatistic() {
            this.advancedDialog = false;
            this.loading = true;
            if (this.statisticType == 1) {
                this.$api.orderStatisticByCust(this.searchObj).then((res) => {
                    if (res.data.code == 1) {
                        this.tableData = [];
                        let dd = res.data.data;
                        this.totalNumber = dd.total;
                        let dt = dd.data;
                        let tt = 0;
                        dt.forEach((e) => {
                            let os = {
                                id: e.cid,
                                name: e.cnumber+"-"+e.cname,
                                dtnum: e.detail.length,
                                detail: e.detail,
                                sumPrice:e.sumPrice,
                                tableData: [],
                                sdesc:this.$common.changeNumDesc(e,'sumAmount','sumParts','sumUnit'),
                                ndesc:this.$common.changeNumDesc(e,'sumNotSendAmount','sumNotSendParts','sumNotSendUnit'),
                                cdesc:this.$common.changeNumDesc(e,'sumSendedAmount','sumSendedParts','sumSendedUnit'),
                            };
                            (tt += e.detail.length),
                            this.tableData.push(os);
                        });
                        this.os_total = tt;
                        this.os_sumUnit = dd.sumUnit;
                        this.os_sumPrice = dd.sumPrice;
                        this.totalSendDesc = this.$common.changeNumDesc(dd,'sumSendedAmount','sumSendedParts','sumSendedUnit');
                        this.totalNotSendDesc = this.$common.changeNumDesc(dd,'sumNotSendAmount','sumNotSendParts','sumNotSendUnit');
                        this.loading = false;
                    }
                });
            } else if (this.statisticType == 2) {
                this.$api.orderStatisticByEmp(this.searchObj).then((res) => {
                    if (res.data.code == 1) {
                        this.tableData = [];
                        let dd = res.data.data;
                        this.totalNumber = dd.total;
                        let dt = dd.data;
                        let tt = 0;
                        dt.forEach((e) => {
                            let os = {
                                id:e.eid,
                                name: e.enumber+"-"+e.ename,
                                dtnum: e.detail.length,
                                detail: e.detail,
                                sumPrice:e.sumPrice,
                                tableData:[],
                                sdesc:this.$common.changeNumDesc(e,'sumAmount','sumParts','sumUnit'),
                                ndesc:this.$common.changeNumDesc(e,'sumNotSendAmount','sumNotSendParts','sumNotSendUnit'),
                                cdesc:this.$common.changeNumDesc(e,'sumSendedAmount','sumSendedParts','sumSendedUnit'),
                            };
                            (tt += e.detail.length),
                            this.tableData.push(os);
                        });
                        this.os_total = tt;
                        this.os_sumUnit = dd.sumUnit;
                        this.os_sumPrice = dd.sumPrice;
                        this.totalSendDesc = this.$common.changeNumDesc(dd,'sumSendedAmount','sumSendedParts','sumSendedUnit');
                        this.totalNotSendDesc = this.$common.changeNumDesc(dd,'sumNotSendAmount','sumNotSendParts','sumNotSendUnit');
                        this.loading = false;
                    }
                });
            } else if (this.statisticType == 3) {
                this.$api.orderStatisticByProd(this.searchObj).then((res) => {
                    if (res.data.code == 1) {
                        this.tableData = [];
                        let dd = res.data.data;
                        this.totalNumber = dd.total;
                        let dt = dd.data;
                        let tt = 0;
                        dt.forEach((e) => {
                            let spec = e.color?'-'+e.color+'-'+e.size:'';
                            let os = {
                                id:e.pid,
                                name: e.pnumber+"-"+e.pname+spec,
                                dtnum: e.detail.length,
                                detail: e.detail,
                                sumPrice:e.sumPrice,
                                tableData:[],
                                sdesc:this.$common.changeNumDesc(e,'sumAmount','sumParts','sumUnit'),
                                ndesc:this.$common.changeNumDesc(e,'sumNotSendAmount','sumNotSendParts','sumNotSendUnit'),
                                cdesc:this.$common.changeNumDesc(e,'sumSendedAmount','sumSendedParts','sumSendedUnit'),
                            };
                            (tt += e.detail.length),
                            this.tableData.push(os);
                        });
                        this.os_total = tt;
                        this.os_sumUnit = dd.sumUnit;
                        this.os_sumPrice = dd.sumPrice;
                        this.totalSendDesc = this.$common.changeNumDesc(dd,'sumSendedAmount','sumSendedParts','sumSendedUnit');
                        this.totalNotSendDesc = this.$common.changeNumDesc(dd,'sumNotSendAmount','sumNotSendParts','sumNotSendUnit');
                        this.loading = false;
                    }
                });
            }
        },
        getClassify() {
            this.$api.productgetProdClassify().then((res) => {
                this.classifyData = res.data.data;
            });
        },
        expandChange(row){
            this.selectRow = row;
            if(row.detail.length>0&&row.detail.length>row.tableData.length){
                this.loading = true;
                let str = row.detail.join(',');
                this.$api.getStatisticDetail({odids:str}).then(res=>{
                    if(res.data.code==1){
                        res.data.data.forEach(e=>{
                            e.sendDesc=this.$common.changeNumDesc(e,'sendedAmount','sendedParts','sendedUnit');
                            e.notSendDesc=this.$common.changeNumDesc(e,'notSendAmount','notSendParts','notSendUnit');
                            e.punit+=this.$global.unit+'/'+this.$global.pack;
                            e.spec=e.color?e.color+"/"+e.size:'标准';
                        })
                        row.tableData = res.data.data;
                    }
                    this.loading = false;
                    this.summaryDetailDialog = true;
                })
            }else{
                this.summaryDetailDialog = true;
            }
        }
    },
};
</script>
